(function(){
'use strict';
if(window.__KDK_DYNAMIC_REAL_SIZES__)return;
window.__KDK_DYNAMIC_REAL_SIZES__=true;
var KEY='kdk_size',letters=['3XS','XXS','XS','S','M','L','XL','XXL','3XL','4XL','5XL','6XL'],observedRoot=null,observedParent=null,observers=[],raf=0;
function norm(s){
  s=String(s||'').trim().toUpperCase().replace(/\s+/g,' ').replace(/(\d),(\d)/g,'$1.$2');
  var alias={'XXXSMALL':'3XS','XXSMALL':'XXS','2XS':'XXS','XSMALL':'XS','EXTRA SMALL':'XS','SMALL':'S','MEDIUM':'M','LARGE':'L','XLARGE':'XL','EXTRA LARGE':'XL','XXLARGE':'XXL','XX LARGE':'XXL','2XL':'XXL','XXXL':'3XL','XXXLARGE':'3XL','ONE SIZE':'TEK BEDEN'};
  return alias[s]||s;
}
function numeric(s){return /^(?:EU|UK|US)?\s*\d+(?:\.\d+)?$/.test(s);}
function compare(a,b){
  var l=letters.indexOf(a),r=letters.indexOf(b);
  if(l!==-1&&r!==-1)return l-r;
  if(l!==-1)return -1;if(r!==-1)return 1;
  var n=numeric(a),m=numeric(b);
  if(n&&m){
    var aPrefix=(a.match(/^(EU|UK|US)/)||[])[0]||'',bPrefix=(b.match(/^(EU|UK|US)/)||[])[0]||'';
    if(aPrefix!==bPrefix)return aPrefix.localeCompare(bPrefix);
    return parseFloat(a.replace(/^(EU|UK|US)\s*/,''))-parseFloat(b.replace(/^(EU|UK|US)\s*/,''));
  }
  if(n)return -1;if(m)return 1;
  return a.localeCompare(b,'tr',{numeric:true,sensitivity:'base'});
}
function rawSizes(card){
  return Array.from(new Set((card.getAttribute('data-kdk-dress-sizes')||'').split('|').map(norm).filter(function(v){return v&&v!=='DEFAULT TITLE'&&v!=='DEFAULT';})));
}
function chosen(){
  return Array.from(new Set((new URL(location.href).searchParams.get(KEY)||'').split(',').map(norm).filter(Boolean)));
}
function draw(){
  var panel=document.querySelector('[data-kdk-dress-panel]');
  var list=document.getElementById('CollectionProductsParent');
  if(!panel||!list)return;
  var cards=Array.from(list.querySelectorAll('[data-kdk-dress-item]')),counts=new Map();
  cards.forEach(function(card){rawSizes(card).forEach(function(v){counts.set(v,(counts.get(v)||0)+1);});});
  var active=chosen(),sizes=Array.from(new Set(Array.from(counts.keys()).concat(active))).sort(compare);
  panel.hidden=sizes.length===0;
  if(!sizes.length)return;
  var numericCount=sizes.filter(numeric).length,alphaCount=sizes.filter(function(v){return letters.indexOf(v)>=0;}).length;
  var header=panel.querySelector('[data-kdk-size-heading]');
  if(header&&header.firstChild)header.firstChild.textContent=numericCount&&alphaCount?'Beden / Numara ':numericCount?'Numara ':'Beden ';
  var group=panel.querySelector('[data-kdk-dress-choices]');if(!group)return;
  group.replaceChildren();
  var previous='';
  sizes.forEach(function(v){
    var section=letters.indexOf(v)>=0?'Harfli bedenler':numeric(v)?'Numaralar':'Diğer bedenler';
    if(alphaCount&&numericCount&&section!==previous){
      var title=document.createElement('div');title.className='kdk-dress-sizes__group';title.textContent=section;group.appendChild(title);
    }
    previous=section;
    var b=document.createElement('button');b.type='button';b.dataset.kdkDressValue=v;
    b.setAttribute('aria-pressed',active.includes(v)?'true':'false');
    b.setAttribute('aria-label',v+' beden; '+(counts.get(v)||0)+' ürün');
    b.appendChild(document.createTextNode(v));
    var small=document.createElement('small');small.textContent=String(counts.get(v)||0);small.setAttribute('aria-hidden','true');
    b.appendChild(small);group.appendChild(b);
  });
  var clear=panel.querySelector('[data-kdk-dress-clear]');if(clear)clear.hidden=active.length===0;
  var pills=panel.querySelector('[data-kdk-dress-selected]');
  if(pills){
    pills.replaceChildren();
    active.forEach(function(v){var b=document.createElement('button');b.type='button';b.dataset.kdkDressRemove=v;b.setAttribute('aria-label',v+' bedenini kaldır');b.textContent=v+' ×';pills.appendChild(b);});
    pills.hidden=active.length===0;
  }
  var shown=0;
  cards.forEach(function(card){
    var real=rawSizes(card);
    var show=!active.length||active.some(function(v){return real.includes(v);});
    card.hidden=!show;if(show)shown++;
    var preview=card.querySelector('[data-kdk-size-peek]');
    if(preview){real.sort(compare);preview.hidden=real.length===0;preview.textContent=real.length?'Beden: '+real.slice(0,7).join(' · ')+(real.length>7?' · +'+(real.length-7):''):'';}
  });
  var counter=list.querySelector('.Product-result .total_products');
  if(counter){
    if(!counter.hasAttribute('data-kdk-original-count'))counter.setAttribute('data-kdk-original-count',counter.textContent.trim());
    counter.textContent=active.length?shown+' ürün':counter.getAttribute('data-kdk-original-count');
  }
  var mobile=document.querySelector('[data-kdk-product-count]');
  if(mobile)mobile.textContent=active.length?shown+' ürün':counter?counter.textContent.trim():cards.length+' ürün';
  var status=panel.querySelector('[data-kdk-dress-status]');if(status)status.textContent=active.length?shown+' ürün':'';
  var container=list.querySelector('[data-collection-products]');
  if(container){
    var empty=list.querySelector('[data-kdk-dress-empty]');
    if(!empty){empty=document.createElement('p');empty.className='kdk-dress-sizes__empty';empty.dataset.kdkDressEmpty='';empty.setAttribute('role','status');empty.textContent='Bu bedenlerde gösterilen ürün yok. Başka bir beden seçebilirsiniz.';container.insertAdjacentElement('afterend',empty);}
    empty.hidden=!active.length||shown>0||!cards.length;
  }
}
function schedule(){if(raf)return;raf=requestAnimationFrame(function(){raf=0;watch();draw();});}
function watch(){
  var root=document.getElementById('CollectionProductsParent'),parent=root&&root.parentElement;
  if(!root||!parent||root===observedRoot&&parent===observedParent)return;
  observers.forEach(function(w){w.disconnect();});observers=[];
  observedRoot=root;observedParent=parent;
  var p=new MutationObserver(function(events){if(events.some(function(e){return Array.from(e.addedNodes).some(function(n){return n.nodeType===1&&n.id==='CollectionProductsParent';});}))schedule();});
  p.observe(parent,{childList:true});observers.push(p);
  var c=new MutationObserver(function(events){if(events.some(function(e){return Array.from(e.addedNodes).some(function(n){return n.nodeType===1&&(n.hasAttribute('data-kdk-dress-item')||n.querySelector&&n.querySelector('[data-kdk-dress-item]'));});}))schedule();});
  c.observe(root,{childList:true,subtree:true});observers.push(c);
}
function change(values){
  var url=new URL(location.href);
  if(values.length)url.searchParams.set(KEY,values.join(','));else url.searchParams.delete(KEY);
  url.searchParams.delete('page');
  history.pushState({kdkStockSizes:true},'',url.pathname+url.search+url.hash);schedule();
}
document.addEventListener('click',function(event){
  var b=event.target.closest('[data-kdk-dress-value],[data-kdk-dress-remove],[data-kdk-dress-clear]');
  if(!b||!document.querySelector('[data-kdk-dress-panel]'))return;
  event.preventDefault();
  if(b.hasAttribute('data-kdk-dress-clear')){change([]);return;}
  var val=b.getAttribute('data-kdk-dress-value')||b.getAttribute('data-kdk-dress-remove');
  var values=chosen(),idx=values.indexOf(val);
  if(idx>=0)values.splice(idx,1);else values.push(val);
  change(values);
});
window.addEventListener('popstate',schedule);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule);else schedule();
document.addEventListener('shopify:section:load',schedule);
})();